var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { SchedulerTask } from './SchedulerTask';
/**
 * Represents the default `viewTask` component rendered by the [KendoReact Scheduler component]({% slug overview_scheduler %}).
 *
 * This is a composite component of the [`SchedulerTask`]({% slug api_scheduler_schedulertask %}).
 */
export var SchedulerViewTask = React.forwardRef(function (props, ref) {
    var taskProp = props.task, _ref = props._ref, taskProps = __rest(props, ["task", "_ref"]);
    var task = React.useRef(null);
    var viewTask = React.useRef(null);
    React.useImperativeHandle(viewTask, function () { return ({ props: props, element: task.current && task.current.element }); });
    React.useImperativeHandle(_ref, function () { return task.current; });
    React.useImperativeHandle(ref, function () { return viewTask.current; });
    var Task = taskProp || defaultProps.task;
    return (React.createElement(Task, __assign({}, taskProps, { _ref: task })));
});
var defaultProps = {
    task: SchedulerTask
};
SchedulerViewTask.defaultProps = defaultProps;
SchedulerViewTask.displayName = 'KendoReactSchedulerViewTask';
//# sourceMappingURL=SchedulerViewTask.js.map